<template>
    <article class="profile">
        <slot :data="slotData"></slot>
    </article>
</template>

<script>
    export default {
        props: {
            user: {required: true},
            assessments: {required: true}
        },
        data() {
            return {
                profile: {}
            }
        },
        computed: {
            slotData() {
                return {
                    profile: this.user,
                    assessments: this.assessments,
                    completed: this.completedAssessments
                }
            },
            completedAssessments(){
                let completed = 0;
                this.assessments.forEach(assessment=>{
                    if(assessment.status === 2){
                        completed++;
                    }
                });
                return completed;
            },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/my_profile/ProfilePage.vue